import type { Card } from "./types.ts";
import { canonical } from "./pinyin.ts";

const FILLER = new Set(["a", "an", "the", "of"]);

// TODO: Preserve meaningful filler words for arbitrary sets; "vitamin A" currently accepts "vitamin".
// TODO: Fold in-word apostrophes without spaces; "don't" and "dont" still grade differently.
export const meaningKey = (s: string): string =>
  s.toLowerCase().replace(/\p{P}+/gu, " ").split(/\s+/).filter((w) => w && !FILLER.has(w)).join(" ") ||
  s.trim().toLowerCase();

export function grade(card: Card, given: string): boolean {
  const options = [card.answer, ...(card.accepted ?? [])];
  if (card.kind === "pinyin" || card.kind === "recall") {
    if (!given.trim()) return false;
    const g = canonical(given);
    return options.some((o) => canonical(o) === g);
  }
  const g = meaningKey(given);
  return g !== "" && options.some((o) => meaningKey(o) === g);
}
